"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var icons_material_1 = require("@mui/icons-material");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var material_1 = require("@mui/material");
var IconButton_1 = __importDefault(require("../buttons/IconButton"));
var BaseStyledDialog_1 = __importDefault(require("./BaseStyledDialog"));
var EntityEditDialog = function (props) {
    var _a = (0, react_1.useState)(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var menuOpen = Boolean(anchorEl);
    var handleMenuOpenClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BaseStyledDialog_1.default, { open: props.open, fullWidth: props.fullWidth, maxWidth: props.maxWidth, onClose: props.handleClose },
            react_1.default.createElement(material_1.DialogTitle, { id: "form-dialog-title", color: "primary", variant: "h3" },
                react_1.default.createElement(material_1.Box, { py: 1, display: "flex", alignItems: "center" },
                    props.title,
                    react_1.default.createElement(material_1.Box, { flexGrow: 1 }),
                    react_1.default.createElement(IconButton_1.default, { size: "small", color: "error", onClick: props.handleClose },
                        react_1.default.createElement(Close_1.default, null)))),
            react_1.default.createElement(material_1.DialogContent, null, props.children),
            react_1.default.createElement(material_1.DialogActions, null,
                props.showMoreMenu &&
                    react_1.default.createElement(material_1.Button, { onClick: handleMenuOpenClick, startIcon: react_1.default.createElement(icons_material_1.MoreVert, null), className: "no-pad", sx: { pl: 0 } }, "More"),
                react_1.default.createElement(material_1.Box, { flexGrow: 1 }),
                react_1.default.createElement(material_1.Button, { variant: "text", color: "secondary", onClick: props.handleClose }, props.editing ? 'Cancel' : 'Close'),
                props.editing && react_1.default.createElement(material_1.Button, { variant: "contained", onClick: props.handleSave, disabled: props.disableSave }, "Save"))),
        props.showMoreMenu &&
            react_1.default.createElement(material_1.Menu, { id: "basic-menu", anchorEl: anchorEl, open: menuOpen, onClose: handleMenuClose, onClick: handleMenuClose, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                } }, props.menuItems)));
};
exports.default = EntityEditDialog;
